export default HTTPClient => ({
  readAllMaster: async (request = { page: 0, perPage: 20, query: '' }) => {
    const page = request.page || 0;
    const perPage = request.perPage || 10;
    const query = request.query || '';

    const resp = await HTTPClient.get(`topics?limit=${perPage}&offset=${perPage * page}&q=${query}`);
    return resp;
  },
  search: async (request = { page: 0, perPage: 20, query: '' }) => {
    const page = request.page || 0;
    const perPage = request.perPage || 10;
    const query = request.query || '';

    const resp = await HTTPClient.get(`topics/graph?limit=${perPage}&offset=${perPage * page}&q=${query}`);
    return resp;
  },
  readAllChildren: async (id) => {
    const resp = await HTTPClient.get(`topics/${id}/children`);
    return resp;
  },
  createTopic: async (parentID, name) => {
    const resp = await HTTPClient.post('topics', {
      body: JSON.stringify({
        name,
        parent_id: parentID,
      }),
    });
    return resp;
  },
  rename: async (id, name) => {
    const resp = await HTTPClient.put(`topics/${id}/`, {
      body: JSON.stringify({
        name,
      }),
    });
    return resp;
  },
  delete: async (id) => {
    const resp = await HTTPClient.delete(`topics/${id}/`);
    return resp;
  },
});
